import { render, staticRenderFns } from "./requested-list.vue?vue&type=template&id=72b613f3&"
import script from "./requested-list.vue?vue&type=script&lang=js&"
export * from "./requested-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports